import type { DashboardUser } from "./api";
import { useState } from "react";

interface McpUserTableProps {
  users: DashboardUser[];
  onDisable: (email: string) => void;
  onEnable: (email: string) => void;
  onResend: (email: string) => void;
}

function StatusBadge({ status }: { status: string }) {
  const cls =
    status === "disabled"
      ? "cx-admin-badge cx-admin-badge--free"
      : "cx-admin-badge cx-admin-badge--max";
  return <span className={cls}>{status === "disabled" ? "disabled" : "active"}</span>;
}

export function McpUserTable({ users, onDisable, onEnable, onResend }: McpUserTableProps) {
  const [confirmDisable, setConfirmDisable] = useState<string | null>(null);

  if (users.length === 0) {
    return (
      <p className="cx-text-secondary cx-admin-empty">
        No MCP accounts yet. Invite one: they get an email to set their password and
        connect Claude.
      </p>
    );
  }

  return (
    <table className="cx-admin-table">
      <thead>
        <tr>
          <th>User</th>
          <th>Tier</th>
          <th>Status</th>
          <th style={{ textAlign: "right" }}>Calls today</th>
          <th style={{ textAlign: "right" }}>30 days</th>
          <th>Last activity</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {users.map((u) => (
          <tr key={u.email} className="cx-admin-user-row">
            <td style={{ fontWeight: 500 }}>{u.email}</td>
            <td>
              <span className="cx-admin-badge cx-admin-badge--max">{u.tier}</span>
            </td>
            <td>
              <StatusBadge status={u.status} />
            </td>
            <td style={{ textAlign: "right", fontWeight: 500 }}>{u.mcp_today}</td>
            <td style={{ textAlign: "right" }}>{u.mcp_30d}</td>
            <td>
              <span className="cx-admin-last-active">
                {u.mcp_last_active ?? "Never"}
              </span>
            </td>
            <td className="cx-admin-actions">
              {u.status !== "disabled" && confirmDisable !== u.email && (
                <button
                  className="cx-admin-btn"
                  style={{ fontSize: "var(--cx-text-xs)" }}
                  onClick={() => onResend(u.email)}
                >
                  Resend invite
                </button>
              )}
              {u.status === "disabled" ? (
                <button
                  className="cx-admin-btn"
                  style={{ fontSize: "var(--cx-text-xs)" }}
                  onClick={() => onEnable(u.email)}
                >
                  Enable
                </button>
              ) : confirmDisable === u.email ? (
                <span className="cx-admin-confirm">
                  <button
                    className="cx-admin-btn cx-admin-btn--danger"
                    style={{ fontSize: "var(--cx-text-xs)" }}
                    onClick={() => {
                      onDisable(u.email);
                      setConfirmDisable(null);
                    }}
                  >
                    Confirm
                  </button>
                  <button
                    className="cx-admin-btn"
                    style={{ fontSize: "var(--cx-text-xs)" }}
                    onClick={() => setConfirmDisable(null)}
                  >
                    Cancel
                  </button>
                </span>
              ) : (
                <button
                  className="cx-admin-btn cx-admin-btn--danger"
                  style={{ fontSize: "var(--cx-text-xs)" }}
                  onClick={() => setConfirmDisable(u.email)}
                >
                  Disable
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
